import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardGuard } from 'common/guards/dashboard.guard';
import { PostloginGuard } from 'common/guards/postlogin.guard';
import { PreloginGuard } from 'common/guards/prelogin.guard';

const routes: Routes = [
    {
        path: 'test',
        loadChildren: () => import('../../common/pages/test/test.module').then((m) => m.TestPageModule),
    },
    {
        path: 'distributor/dashboard',
        loadChildren: () => import('../../common/pages/postlogin/dashboard/dashboard.module').then((m) => m.DashboardPageModule),
        canActivate: [DashboardGuard],
    },
    {
        path: 'distributor/wishes',
        loadChildren: () => import('../../common/pages/postlogin/wishes/wishes.module').then((m) => m.WishesPageModule),
        canActivate: [PostloginGuard],
    },
    {
        path: 'distributor/nominee-details',
        loadChildren: () => import('../../common/pages/postlogin/nominee-details/nominee-details.module').then((m) => m.NomineeDetailsPageModule),
        canActivate: [PostloginGuard],
    },
    {
        path: 'distributor/profile',
        loadChildren: () => import('../../common/pages/postlogin/profile/profile.module').then((m) => m.ProfilePageModule),
        canActivate: [PostloginGuard],
    },
    {
        path: 'distributor/transact',
        loadChildren: () => import('../../common/pages/postlogin/transaction/transaction.module').then((m) => m.TransactionPageModule),
        canActivate: [PostloginGuard],
    },
    {
        path: 'distributor/investor/:id',
        loadChildren: () => import('../../common/pages/postlogin/investor/investor.module').then((m) => m.InvestorModule),
        canActivate: [PostloginGuard],
    },
    {
        path: 'distributor/sip-report',
        loadChildren: () => import('../../common/pages/postlogin/reports/sip-report/sip-report.module').then((m) => m.SipReportPageModule),
        canActivate: [PostloginGuard],
    },
    {
        path: 'distributor/stp-report',
        loadChildren: () => import('../../common/pages/postlogin/reports/stp-report/stp-report.module').then((m) => m.StpReportPageModule),
        canActivate: [PostloginGuard],
    },
    {
        path: 'distributor/swp-report',
        loadChildren: () => import('../../common/pages/postlogin/reports/swp-report/swp-report.module').then((m) => m.SwpReportPageModule),
        canActivate: [PostloginGuard],
    },
    {
        path: 'distributor/transaction-history',
        loadChildren: () => import('../../common/pages/postlogin/transaction-history/transaction-history.module').then((m) => m.TransactionHistoryPageModule),
        canActivate: [PostloginGuard],
    },
    {
        path: 'distributor/opportunity',
        loadChildren: () => import('../../common/pages/postlogin/opportunity/opportunity.module').then((m) => m.OpportunityPageModule),
        canActivate: [PostloginGuard],
    },
    {
        path: 'distributor/prostart',
        loadChildren: () => import('../../common/pages/postlogin/prostart/prostart.module').then((m) => m.ProstartPageModule),
        canActivate: [PostloginGuard],
    },
    {
        path: 'distributor/account-statement',
        loadChildren: () => import('../../common/pages/postlogin/statements/statements.module').then((m) => m.StatementsPageModule),
        canActivate: [PostloginGuard],
    },
    {
        path: 'distributor/capital-gain-statement',
        loadChildren: () => import('../../common/pages/postlogin/statements/statements.module').then((m) => m.StatementsPageModule),
        canActivate: [PostloginGuard],
    },
    // {
    //     path: 'distributor/brokerage-report',
    //     loadChildren: () => import('../../common/pages/postlogin/brokerage-report/brokerage-report.module').then((m) => m.BrokerageReportPageModule),
    //     canActivate: [PostloginGuard],
    // },
    {
        path: 'distributor/nav',
        loadChildren: () => import('../../common/pages/postlogin/nav/nav.module').then((m) => m.NavPageModule),
        canActivate: [PostloginGuard],
    },
    {
        path: 'distributor/feedback-and-queries',
        loadChildren: () => import('../../common/pages/postlogin/feedback-and-query/feedback-and-query.module').then((m) => m.FeedbackAndQuiresPageModule),
        canActivate: [PostloginGuard],
    },
    {
        path: 'distributor/co-branding',
        loadChildren: () => import('../../common/pages/postlogin/co-branding/co-branding.module').then((m) => m.CoBrandingPageModule),
        canActivate: [PostloginGuard],
    },
    {
        path: 'distributor/bankmandate-list',
        loadChildren: () => import('../../common/pages/postlogin/bankmandate/bankmandate-list/bankmandate-list.module').then((m) => m.BankmandateListPageModule),
        canActivate: [PostloginGuard],
    },
    {
        path: 'distributor/bankmandate-form',
        loadChildren: () => import('../../common/pages/postlogin/bankmandate/bankmandate-form/bankmandate-form.module').then((m) => m.BankmandateFormPageModule),
        canActivate: [PostloginGuard],
    },
    {
        path: 'distributor/brokerage-report-payout',
        loadChildren: () => import('../../common/pages/postlogin/brokerage-report-payout/brokerage-report-payout.module').then((m) => m.BrokerageReportPayoutPageModule),
    },
    {
        path: 'distributor/notifications',
        loadChildren: () => import('../../common/pages/postlogin/notification/notification.module').then((m) => m.NotificationModule),
        canActivate: [PostloginGuard],
    },
    // {
    //     path: 'distributor/empanelment',
    //     loadChildren: () => import('../../common/pages/postlogin/empanelment/empanelment.module').then((m) => m.EmpanelmentPageModule),
    // },
    {
        path: '',
        loadChildren: () => import('../../common/pages/prelogin/prelogin.module').then((m) => m.PreloginPageModule),
        canActivate: [PreloginGuard],
    },

    // {
    //     path: '**',
    //     redirectTo: 'dashboard',
    // },
];
@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', anchorScrolling: 'enabled' })],
    exports: [RouterModule],
})
export class AppRoutingModule { }
